/* eslint-disable */
export default {
  Home: '홈',
  Mobile: '모바일',
  Work: '직장',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
